<template>
  <Section
    :title="
      gettext(
        'Connaissez-vous la consommation et la puissance de votre chaudière?'
      )
    "
  >
    <RadiosList
      :value="simulation.consumptionKnown"
      :field="field"
      @change="
        (val) =>
          updateSimulation({ consumptionKnown: val.target.value === 'true' })
      "
    >
      <template #default="slotProps">
        <div class="h5 mrgv0">{{ slotProps.choice[1] }}</div>
      </template>
    </RadiosList>
  </Section>
</template>

<script setup>
import { computed } from 'vue';

import Section from '@/components/simulation/Section.vue';
import RadiosList from '@/components/forms/fields/RadiosList.vue';
import { useSimulation } from '@/composables/useSimulation';

const { simulation, updateSimulation } = useSimulation();

const field = computed(() => {
  return {
    label: gettext(
      'Connaissez-vous la consommation et la puissance de votre chaudière?'
    ),
    name: 'consumption-known',
    choices: [
      [true, gettext('Oui')],
      [false, gettext('Non, je souhaite une estimation')],
    ],
  };
});
</script>
